import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Ticket } from 'src/app/models/ticket-models/ticket.model';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-tickets-ticket-centers-card',
  templateUrl: './tickets-ticket-centers-card.component.html',
  styleUrls: ['./tickets-ticket-centers-card.component.scss']
})
export class TicketsTicketCentersCardComponent implements OnInit, OnDestroy {

  @Input() ticket: Ticket;
  centers;
  selectedCenters;
  updateTicketCentersSubscription: Subscription;

  constructor(private ticketsService: TicketsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.centers = this.userStorageService.getCenterList();
  }

  public duallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.updateTicketCenters(aux);
    }
  }

  public updateTicketCenters(centers) {
    this.updateTicketCentersSubscription = this.ticketsService.updateTicketCenters(this.ticket.InternalId, this.filterCentersInternalIds(centers)).subscribe(
      (res) => {
        this.ticketsService.refreshTicket();
        this.snackbarService.open('tickets-page.snackbar messages.update ticket success', 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }


  private filterCentersInternalIds(centers) {
    if (centers && (centers.length > 0)) {
      return centers.map(c => c.InternalId);
    } else {
      return [];
    }
  }

  ngOnDestroy() {
    if (this.updateTicketCentersSubscription) { this.updateTicketCentersSubscription.unsubscribe(); }
  }

}
